export const SUPPORTED_LANGUAGE_CODES = {
  ENGLISH: { GO: 'en-us', READER: 'en-US' },
  SPANISH: { GO: 'es-mx', READER: 'es-ES' },
};
